// src/components/PasswordPopup.js
import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
} from '@mui/material';

const PasswordPopup = ({ passwordPopupOpen, setPasswordPopupOpen, saveEmployeePassword }) => {
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handlePasswordPopupClose = () => {
    setPasswordPopupOpen(false);
  }

  const handleNewPasswordSubmit = () => {

    if (password === confirmPassword && password.length >= 6) {
        saveEmployeePassword(password);
        alert('パスワードが登録されました');
        setPasswordPopupOpen(false);
    } else {
        alert('パスワードが一致しないか、6文字以上ではありません。再度入力してください。');
    }
  };


  return (
    <>
        <Dialog open={passwordPopupOpen} >
            <DialogTitle>パスワード登録</DialogTitle>
            <DialogContent>
                <DialogContentText fontSize={14}>
                    パスワードが未登録です。登録してください。<br />
                    6文字以上で設定してください。<br/>
                    <span style={{ fontSize: 14, color: "red" }}>
                        一度設定したパスワードは忘れずに管理してください!!
                    </span>
                </DialogContentText>
                <TextField
                    sx={{
                        mt:2
                    }}
                    autoFocus
                    size='small'
                    margin="dense"
                    id="password"
                    label="パスワード"
                    type="password"
                    fullWidth
                    variant="outlined"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <TextField
                    size='small'
                    margin="dense"
                    id="confirmPassword"
                    label="パスワード確認"
                    type="password"
                    fullWidth
                    variant="outlined"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleNewPasswordSubmit} color="primary">
                    登録
                </Button>
                <Button onClick={handlePasswordPopupClose} color="error">
                    キャンセル
                </Button>
            </DialogActions>
        </Dialog>
    </>
  );
};

export default PasswordPopup;